var map = {
	"./img1.jpg": 574,
	"./img2.jpg": 345,
	"./img3.jpg": 620,
	"./img4.jpg": 783,
	"./img5.jpg": 114,
	"./img6.jpg": 21,
	"./img7.jpg": 448,
	"./img8.jpg": 203,
	"./img9.jpg": 366
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 291;